<template>
    <template-block
        v-if="localModel"
        type="Mellanrum"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <input-with-validation
                label="Höjd"
                :vid="vid + '.height'"
                v-model="localModel.height"
                @input="emitChange"
                placeholder="Höjd"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
        </div>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import InputWithValidation from '@components/Form/InputWithValidation.vue';

export default {
    name: 'BlockDivider',
    components: {
        InputWithValidation,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'spacer.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'spacer',
                id: newVal.id || genUUID(),
                height: newVal.height ?? 10,
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
